import styled from 'styled-components';
import { compose } from 'styled-system';

import {
  BORDER,
  COMMON,
  LAYOUT,
  SystemBorderProps,
  SystemCommonProps,
  SystemLayoutProps
} from '../theme/constants';
import sx, { SxProp } from '../theme/utils/sx';

const composeSystem = compose(COMMON, LAYOUT, BORDER);

type ComposeSystemProps = SystemCommonProps &
  SystemLayoutProps &
  SystemBorderProps;

/** List Item */
export interface StyledListItemProps extends SxProp, ComposeSystemProps {
  isLoading?: boolean;
}

export const StyledListItem = styled.li<StyledListItemProps>`
  border-bottom-color: ${({ isLoading }) => (isLoading ? '#eee' : '#bdbdbd')};
  border-bottom-style: solid;
  display: flex;
  text-decoration: none;

  ${composeSystem}
  ${sx}

  li& {
    list-style: none;
  }

  button& {
    cursor: pointer;
    background: transparent;
    border-left: none;
    border-right: none;
    border-top: none;
    text-align: left;
  }
  button&:disabled {
    cursor: default;
    opacity: 0.5;
  }
  button&:focus {
    outline: none;
  }
`;

StyledListItem.defaultProps = {
  px: 6,
  py: 4
};

export const StyledListItemDescription = styled.span`
  display: block;
  margin: 0;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.375rem;
  color: #565656;
`;

export const StyledListItemTitle = styled.span`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.125rem;
  color: #3a3a3a;
  margin-bottom: 1px;
`;

/** List */
export interface StyledListProps extends SxProp, ComposeSystemProps {
  divider?: boolean;
  lastDivider?: boolean;
}

export const StyledList = styled.ul<StyledListProps>`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  ${composeSystem}
  ${sx}

  & ${StyledListItem} {
    border-bottom-width: ${({ divider }) => (divider ? '1px' : '0')};
  }

  & ${StyledListItem}:last-child {
    ${({ lastDivider }) => !lastDivider && 'border-bottom: none'};
  }

  & ${StyledListItemTitle} {
    color: #3a3a3a;
  }
  & ${StyledListItemDescription} {
    color: #565656;
  }
`;

export const StyledListItemIcon = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 16px;
`;

export const StyledListItemTextContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;
  align-self: center;
`;

export const StyledListItemAction = styled.div`
  align-self: center;
`;
